import React from "react";
import { Redirect } from "react-router-dom";
import { candidate } from "routes/paths";

export default () => <Redirect to={candidate.main} />;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Main/index.js